import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { Divider, Grid, Tooltip } from '@mui/material';
import { translations } from '../../../../../locales/translations';
import { useTranslation } from 'react-i18next';
import { DisplayFieldVertical } from '../DisplayFieldVertical';
import { useSelector } from 'react-redux';
import { selectCurrency } from '../../slice/selectors';
import { DisplayOldToNew } from './DisplayOldToNew';
import { TermTable } from './TermTable';
import { AmendmentStatus } from '../../slice/types';
import { commonStyle } from '../../../../../styles/theme/themes';
import { DisplayFieldHorizontal } from '../DisplayFieldHorizontal';
import { SectionStatusBlock } from './SectionStatusBlock';
import moment from 'moment';
export function TermCard(props) {
  const { t } = useTranslation();
  const terminationData = props.data.data;
  const relatedSections = props.data.relatedSections;
  const terminationDataStatus = props.data.status;
  const status =
    terminationDataStatus === AmendmentStatus.PENDING
      ? translations.biType.Pending
      : translations.biType.Complete;
  const showTerminationAction = (terminationData.action ?? 'normal').toLowerCase() !== 'normal';
  const currency = useSelector(selectCurrency);
  const [selecting, setSelecting] = useState(false);

  const directToURL = () => {
    if (terminationData.workflowURL) {
      window.open(terminationData.workflowURL, '_blank');
    }
  };
  // const updateDisplayTermination = () => {
  //   setSelecting(!selecting);
  // };
  const WrapperOrTooltip = props.data.statusReasons?.['termination'] ? TooltipWrapper : Wrapper;

  return (
    <WrapperOrTooltip title={props.data.statusReasons?.['termination']}>
      {terminationData &&
      <div
        className={`card ${terminationDataStatus === AmendmentStatus.COMPLETE ? 'complete' : 'pending'} ${selecting && 'highlight'}`}>
        <Grid container className='header'>
          <Grid item md={4}>
            {t(translations.biType.termination)} {showTerminationAction && <strong>({t(terminationData.action)})</strong>}
          </Grid>
          <Grid item md={4} className='center workflow-url' onClick={directToURL}>
            {terminationData.workflowId}
          </Grid>
          <Grid item md={4} className='right'>
            {t(status)}
          </Grid>
        </Grid>
        <Divider />
        <div className='content'>
          <DisplayFieldHorizontal
            label={translations.contractDetail.amendment.approvalDate}
            value={moment(terminationData.approvalDate).format('YYYY-MM-DD HH:mm:ss')}
          />
          <Grid container className='row'>
            <Grid item xs={12} md={12} lg={6}>
              <DisplayFieldVertical
                label={translations.contractDetail.amendment.termination.termType}
                value={terminationData.termType}
              />
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
              <DisplayFieldVertical
                label={translations.contractDetail.amendment.termination.totalCharge}
                value={`${currency} ${Number(terminationData.totalCharge).toLocaleString(
                  undefined,
                  { maximumFractionDigits: 2 },
                )}`}
              />
            </Grid>
          </Grid>
          <Grid container className='row'>
            <Grid item xs={12} md={12} lg={12}>
              <DisplayFieldVertical
                label={translations.contractDetail.amendment.termination.contractEndDate}
                value={terminationData.contractEndDate}
              />
            </Grid>
          </Grid>
          <Grid container className='row'>
            <Grid item xs={12} md={12} lg={6}>
              <DisplayFieldVertical
                label={translations.contractDetail.amendment.termination.accountMoveOut}
                value={terminationData.accountMoveOut}
              />
            </Grid>
            <Grid item xs={12} md={12} lg={6}>
              <DisplayFieldVertical
                label={translations.contractDetail.amendment.termination.contractMoveOut}
                value={terminationData.contractMoveOut}
              />
            </Grid>
          </Grid>
          <DisplayOldToNew
            label={translations.contractDetail.contractInformation.reqTermDate}
            oldValue={terminationData.oldTerminationDate}
            newValue={terminationData.newTerminationDate}
          />
          {relatedSections &&
          <div className='row status'>
            {Object.keys(relatedSections).map((item, index) => (
              <SectionStatusBlock sectionName={item} sectionStatus={relatedSections[item]} />
            ))}
          </div>
          }
          <TermTable contractLineData={terminationData.products} />
          { terminationData.remarksToFinance && <Grid container className='row'>
            <Grid item marginTop={3} xs={12} md={12} lg={12}>
              <DisplayFieldVertical
                label={translations.contractDetail.amendment.remarksFromSunEOffice}
                value={terminationData.remarksToFinance}
                minRows={3}
              />
            </Grid>
          </Grid>
          }
        </div>
      </div>
      }
    </WrapperOrTooltip>
  );
}

const Wrapper = styled.div`
  .card {
    padding: 5px;
    margin: 5px 0;
    border-radius: 5px;
    box-shadow: ${commonStyle.boxShadow};
  }

  .highlight {
    border: 2px solid ${p => p.theme.primary};
    margin: -2px -2px -2px -2px;
  }

  .complete {
    background-color: ${p => p.theme.complete};
  }

  .pending {
    background-color: ${p => p.theme.pending};
  }

  .header {
    .workflow-url {
      cursor: pointer;
      text-decoration: underline;

      &:hover {
        opacity: 0.8;
      }
    }

    .center {
      text-align: center;
    }

    .right {
      text-align: right;
    }
  }

  .content {
    background-color: white;
    padding-top: 5px;

    .row {
      padding-top: 5px;
    }

    .status {
      display: flex;
      margin: 0 5px;
    }
  }
`;

const TooltipWrapper = ({children, title}) => {
  return (
    <Tooltip title={title}>
      <Wrapper>{children}</Wrapper>
    </Tooltip>
  )
}